import React from 'react';
import Navigation from "./Navigation";
import Playground from "./Playground";

const SectionProjets = () => {
    return (
        <div className="section2" id="section2">
            <Navigation/>
            <h1>Projets</h1>
            <Playground />
        </div>
    );
};

export default SectionProjets;